// Arqum 2026-10-16.
(function (scope) {
  'use strict';
  const SHOP = 'wdpa1m-fi.myshopify.com';
  const LOCK = 'ips-ad-summary-write:' + SHOP + ':v1';
  const OFFER_KEY = 'ips_collagen_offer';
  const PACK_KEY = 'ips_collagen_pack';
  const RESULT_KEY = 'ips_collagen_result';
  const EXPIRY = '2026-10-20T21:59:00Z';
  const OFFERS = ['20', '50', 'bogo'];
  const PACKS = { f: ['f'], m: ['m'], ff: ['f', 'f'], fm: ['f', 'm'], mm: ['m', 'm'] };
  const normal = value => String(value || '').trim().toUpperCase();
  const integer = value => Number.isSafeInteger(value) && value >= 0;
  function normalizeRoot(value) {
    if (typeof value !== 'string' || !value.startsWith('/')) return null;
    const root = value.endsWith('/') ? value : value + '/';
    return /^\/(?:[A-Za-z0-9_-]+\/)*$/.test(root) ? root : null;
  }

  function parseArrival(href, config) {
    const url = new URL(href);
    const root = normalizeRoot(config.root);
    if (!root || ![root.replace(/\/$/, ''), root + 'cart'].includes(url.pathname.replace(/\/$/, ''))) return null;
    if ([OFFER_KEY, PACK_KEY, RESULT_KEY].some(key => url.searchParams.getAll(key).length > 1)) return null;
    let offer = url.searchParams.get(OFFER_KEY);
    let pack = url.searchParams.get(PACK_KEY);
    let mode = 'arrival';
    if (!offer && url.searchParams.has(RESULT_KEY)) {
      const parts = url.searchParams.get(RESULT_KEY).split(':');
      if (parts.length !== 2) return null;
      [offer, pack] = parts;
      mode = 'result';
    }
    if (!OFFERS.includes(offer)) return null;
    pack = pack || (offer === 'bogo' ? 'ff' : 'f');
    if (!(offer === 'bogo' ? ['ff', 'fm', 'mm'] : ['f', 'm']).includes(pack)) return null;
    if (!config.offers?.[offer]?.code || !PACKS[pack]) return null;
    const targets = {};
    for (const product of PACKS[pack]) {
      const id = config.variants?.[product];
      if (!/^\d+$/.test(String(id))) return null;
      targets[id] = (targets[id] || 0) + 1;
    }
    const clean = new URL(url.href);
    clean.searchParams.delete(OFFER_KEY);
    clean.searchParams.delete(PACK_KEY);
    clean.searchParams.set(RESULT_KEY, offer + ':' + pack);
    return { offer, pack, targets, mode, resultUrl: clean.href };
  }

  function inspectCart(cart, arrival) {
    if (!cart || !Array.isArray(cart.items) || !integer(cart.item_count)) throw new Error('cart_unavailable');
    const quantities = {};
    for (const item of cart.items) {
      if (!integer(item.quantity)) throw new Error('cart_unavailable');
      if (!item.selling_plan_allocation) quantities[item.variant_id] = (quantities[item.variant_id] || 0) + item.quantity;
    }
    const missing = Object.entries(arrival.targets).flatMap(([id, target]) => {
      const quantity = Math.max(0, target - (quantities[id] || 0));
      return quantity ? [{ id: Number(id), quantity }] : [];
    });
    return { missing, present: missing.length === 0 };
  }

  function appliedDiscount(cart, offer) {
    const allowed = new Set([offer.code, ...(offer.titles || [])].map(normal));
    const applications = [];
    for (const entry of cart.cart_level_discount_applications || []) applications.push({ application: entry, amount: entry.total_allocated_amount });
    for (const item of cart.items || []) {
      for (const entry of item.line_level_discount_allocations || []) applications.push({ application: entry.discount_application, amount: entry.amount });
      for (const entry of item.discounts || []) applications.push({ application: entry, amount: entry.amount });
    }
    return applications.some(({ application, amount }) => application && Number(amount) > 0 &&
      (allowed.has(normal(application.code)) || allowed.has(normal(application.title))));
  }

  function createController(config, io) {
    let running = null;
    let queuedVerify = null;
    let verifyRequests = 0;
    let revision = 0;
    let arrival = parseArrival(io.href(), config);
    let disposed = false;
    let presenting = false;
    const presentationListeners = new Set();
    const text = config.text || {};
    const notify = (state, key, retry = false) => {
      if (!disposed) io.notice({ state, message: text[key] || text.unavailable || 'Your offer could not be confirmed. Please review your cart.', retry });
      return { state };
    };
    const showApplied = () => notify('applied', arrival.offer === 'bogo' ? 'success_bogo' : 'success_' + arrival.offer);
    async function fresh() {
      const cart = await io.request('cart.js', { cache: 'no-store' });
      inspectCart(cart, arrival);
      return cart;
    }
    const expired = () => {
      const deadline = Date.parse(config.expiresAt || EXPIRY);
      return !Number.isFinite(deadline) || (io.now ? io.now() : Date.now()) >= deadline;
    };
    async function presentCart(cart) {
      presenting = true;
      try { await io.presentCart(cart); }
      finally { presenting = false; presentationListeners.forEach(listener => listener()); }
    }
    async function work(apply, present = false) {
      if (disposed || !config.enabled || !arrival) return { state: 'ignored' };
      const generation = revision;
      const current = () => !disposed && generation === revision;
      const settled = (state, key, retry) => current() ? notify(state, key, retry) : { state: 'superseded' };
      const offer = config.offers[arrival.offer];
      if (expired()) return settled('expired', 'expired', false);
      if (apply || present) notify('pending', 'pending');
      try {
        return await io.lock(LOCK, async () => {
          let cart = await fresh();
          if (!current()) return { state: 'superseded' };
          if (expired()) return settled('expired', 'expired', false);
          if (!apply) {
            if (!inspectCart(cart, arrival).present || !appliedDiscount(cart, offer)) return settled('unconfirmed', 'not_applied', true);
            if (present) {
              await presentCart(cart);
              if (!current()) return { state: 'superseded' };
            }
            return expired() ? settled('expired', 'expired', false) : showApplied();
          }
          const plan = inspectCart(cart, arrival);
          if (plan.missing.length) {
            try { await io.request('cart/add.js', { method: 'POST', body: { items: plan.missing } }); }
            catch {
              cart = await fresh();
              if (!inspectCart(cart, arrival).present) return settled('unavailable', 'stock_error', true);
            }
            cart = await fresh();
            if (!inspectCart(cart, arrival).present) return settled('unavailable', 'stock_error', true);
          }
          if (!current()) return { state: 'superseded' };
          if (expired()) return settled('expired', 'expired', false);
          try {
            await io.request('cart/update.js', { method: 'POST', body: { discount: '' } });
            if (!current()) return { state: 'superseded' };
            if (expired()) return settled('expired', 'expired', false);
            await io.request('cart/update.js', { method: 'POST', body: { discount: offer.code } });
          } catch {
            cart = await fresh();
            if (!appliedDiscount(cart, offer)) return settled('unconfirmed', 'not_applied', true);
          }
          cart = await fresh();
          if (!current()) return { state: 'superseded' };
          if (expired()) return settled('expired', 'expired', false);
          if (!inspectCart(cart, arrival).present || !appliedDiscount(cart, offer)) return settled('unconfirmed', 'not_applied', true);
          await presentCart(cart);
          if (!current()) return { state: 'superseded' };
          if (expired()) return settled('expired', 'expired', false);
          arrival = { ...arrival, mode: 'result' };
          io.replaceUrl(arrival.resultUrl);
          return showApplied();
        });
      } catch { return settled('unavailable', 'unavailable', true); }
    }
    function serial(apply, present = false) {
      if (!running) running = work(apply, present).finally(() => { running = null; });
      return running;
    }
    function verify() {
      verifyRequests++;
      if (!queuedVerify) queuedVerify = (async () => {
        let result;
        let requested;
        do {
          requested = verifyRequests;
          if (running) await running;
          result = await serial(false);
        } while (!disposed && requested !== verifyRequests);
        return result;
      })().finally(() => { queuedVerify = null; });
      return queuedVerify;
    }
    return {
      start: () => serial(arrival?.mode === 'arrival', true),
      verify,
      retry: () => serial(true),
      pending: () => { revision++; return arrival && notify('pending', 'pending'); },
      isPresenting: () => presenting,
      onPresentationSettled: listener => { presentationListeners.add(listener); return () => presentationListeners.delete(listener); },
      dispose() { disposed = true; },
      arrival: () => arrival
    };
  }

  function attachCartRechecks(env, controller, box) {
    const document = env.document;
    const listeners = [];
    let disposed = false;
    let scheduled = false;
    let presentationChanged = false;
    const listen = (target, type, handler, capture = false) => {
      target.addEventListener(type, handler, capture);
      listeners.push(() => target.removeEventListener(type, handler, capture));
    };
    const busy = () => Boolean(document.querySelector('[data-ips-discount-form] [aria-busy="true"], [data-ips-remove-discount][aria-busy="true"], .cart__items--disabled') ||
      Array.from(document.querySelectorAll('cart-items, cart-drawer-items')).some(element => element.quantityUpdatePending));
    const verifyCompleted = () => {
      if (disposed || scheduled) return;
      scheduled = true;
      Promise.resolve().then(() => {
        scheduled = false;
        if (!disposed && !busy()) controller.verify();
      });
    };
    const started = () => controller.pending();
    const stopPresentationListener = controller.onPresentationSettled?.(() => {
      if (presentationChanged) { presentationChanged = false; verifyCompleted(); }
    });
    const completed = event => {
      started();
      const promise = event?.promise || event?.detail?.promise;
      if (promise?.then) Promise.resolve(promise).then(verifyCompleted, verifyCompleted);
      else verifyCompleted();
    };
    ['ips:cart-updated', 'cart:updated', 'cart:change', 'cart:refresh', 'ajaxProduct:added', 'shopify:cart:discount-update', 'shopify:cart:lines-update'].forEach(type => listen(document, type, completed));
    listen(document, 'submit', event => {
      if (event.target?.closest?.('[data-ips-discount-form], form[action*="/cart"]')) started();
    }, true);
    listen(document, 'click', event => {
      if (!box.contains(event.target) && event.target?.closest?.('[data-ips-remove-discount], cart-remove-button, quantity-input button')) started();
    }, true);
    listen(document, 'change', event => {
      if (!box.contains(event.target) && event.target?.matches?.('input[name="updates[]"]')) started();
    }, true);
    const roots = new Set();
    const items = document.querySelector('cart-items');
    const footer = document.querySelector('#main-cart-footer');
    const drawer = document.querySelector('cart-drawer');
    if (items) roots.add(items.closest('.shopify-section') || items);
    if (footer) roots.add(footer.closest('.shopify-section') || footer);
    if (drawer) roots.add(drawer);
    const observer = typeof env.MutationObserver === 'function' ? new env.MutationObserver(records => {
      if (controller.isPresenting?.()) { presentationChanged = true; return; }
      const changed = records.some(record => {
        if (box.contains(record.target)) return false;
        const nodes = [...(record.addedNodes || []), ...(record.removedNodes || [])];
        if (nodes.length && nodes.every(node => node === box || box.contains(node))) return false;
        if (record.type === 'attributes' && record.attributeName === 'class' &&
          !record.target.matches?.('#main-cart-items, #CartDrawer-CartItems')) return false;
        return true;
      });
      if (changed) { started(); verifyCompleted(); }
    }) : null;
    roots.forEach(root => observer?.observe(root, { childList: true, subtree: true, characterData: true, attributes: true,
      attributeFilter: ['aria-busy', 'disabled', 'hidden', 'class'] }));
    const returned = () => {
      if (controller.arrival()?.mode !== 'arrival') started();
      verifyCompleted();
    };
    listen(env, 'pageshow', returned);
    listen(env, 'focus', returned);
    listen(document, 'visibilitychange', () => { if (document.visibilityState === 'visible') returned(); });
    return { dispose() { disposed = true; observer?.disconnect(); stopPresentationListener?.(); listeners.forEach(remove => remove()); } };
  }

  function browserIo(env, config, notice) {
    async function bounded(promise) {
      let timer;
      try {
        return await Promise.race([promise, new Promise((resolve, reject) => {
          timer = env.setTimeout(() => reject(new Error('drawer_unavailable')), 8000);
        })]);
      } finally { env.clearTimeout(timer); }
    }
    async function waitForOpen(drawer) {
      await new Promise((resolve, reject) => {
        let poll;
        let timeout;
        const finish = error => {
          env.clearTimeout(poll);
          env.clearTimeout(timeout);
          if (error) reject(error); else resolve();
        };
        const check = () => {
          if (drawer.classList.contains('active')) finish();
          else poll = env.setTimeout(check, 16);
        };
        timeout = env.setTimeout(() => finish(drawer.classList.contains('active') ? null : new Error('drawer_unavailable')), 8000);
        check();
      });
    }
    async function getDrawer() {
      let drawer = env.document.querySelector('cart-drawer');
      if (drawer && (typeof drawer.refreshContents !== 'function' || typeof drawer.open !== 'function') && env.customElements?.whenDefined) {
        await bounded(env.customElements.whenDefined('cart-drawer'));
        drawer = env.document.querySelector('cart-drawer');
      }
      if (!drawer || typeof drawer.refreshContents !== 'function' || typeof drawer.open !== 'function') throw new Error('drawer_unavailable');
      return drawer;
    }
    async function openCart() {
      const drawer = await getDrawer();
      drawer.setActiveElement?.(env.document.getElementById('cart-icon-bubble'));
      drawer.open();
      await waitForOpen(drawer);
    }
    function endpoint(path) {
      if (!['cart.js', 'cart/add.js', 'cart/update.js'].includes(path)) throw new Error('cart_endpoint_unavailable');
      return new URL(config.root + path, env.location.origin).href;
    }
    return {
      href: () => env.location.href,
      notice,
      openCart,
      replaceUrl: href => env.history.replaceState(env.history.state, '', href),
      async presentCart() {
        const drawer = await getDrawer();
        const sections = await this.request('sections');
        if (!sections?.['cart-drawer'] || !sections?.['cart-icon-bubble']) throw new Error('drawer_unavailable');
        const parser = new env.DOMParser();
        const next = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const bubble = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        if (!next.querySelector('cart-drawer #CartDrawer') || !bubble.querySelector('.shopify-section') || !drawer.querySelector('#CartDrawer')) throw new Error('drawer_unavailable');
        // Refresh the offer independently of the homepage's general shopping toast. Arqum 2026-10-17.
        await bounded(drawer.refreshContents({ sections }));
        const desktop = env.matchMedia ? env.matchMedia('(min-width: 750px)').matches : Number(env.innerWidth) >= 750;
        if (config.openDrawer === true || (config.openDrawer === 'desktop' && desktop)) await openCart();
      },
      async lock(name, work) {
        if (typeof env.navigator?.locks?.request !== 'function') throw new Error('coordination_unavailable');
        const abort = new env.AbortController();
        const timer = env.setTimeout(() => abort.abort(), 8000);
        try {
          return await env.navigator.locks.request(name, { mode: 'exclusive', signal: abort.signal }, async lock => {
            env.clearTimeout(timer);
            if (!lock || lock.name !== name || lock.mode !== 'exclusive') throw new Error('coordination_unavailable');
            return work();
          });
        } finally { env.clearTimeout(timer); }
      },
      async request(path, options = {}) {
        const abort = new env.AbortController();
        const timer = env.setTimeout(() => abort.abort(), 8000);
        try {
          const request = { method: options.method || 'GET', cache: 'no-store', credentials: 'same-origin', mode: 'same-origin',
            redirect: 'error', referrerPolicy: 'same-origin', signal: abort.signal };
          if (options.body) {
            request.headers = { 'Content-Type': 'application/json' };
            request.body = JSON.stringify(options.body);
          }
          let url;
          if (path === 'sections') {
            url = new URL(env.location.href);
            url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
          } else url = endpoint(path);
          const response = await env.fetch(url.href || url, request);
          if (!response.ok) throw new Error('cart_request_failed');
          return await response.json();
        } finally { env.clearTimeout(timer); }
      }
    };
  }

  function createNotice(env, box, options = {}) {
    const message = box.querySelector('[data-collagen-message]');
    const retry = box.querySelector('[data-collagen-retry]');
    const view = box.querySelector('[data-collagen-view-cart]');
    const check = box.querySelector('[data-collagen-check]');
    let timer;
    let dismissed = false;
    let successShown = false;
    const hide = () => { env.clearTimeout(timer); box.hidden = true; };
    const position = () => {
      if (box.hidden) return;
      const header = env.document.querySelector('.section-header');
      const bottom = header?.getBoundingClientRect?.().bottom || 0;
      const viewport = Number(env.innerHeight) || 800;
      const top = Math.round(Math.max(12, Math.min(bottom + 10, Math.max(12, viewport - 160))));
      box.style?.setProperty('--ips-collagen-notice-top', top + 'px');
      const width = Number(env.innerWidth) || 390;
      const drawer = env.document.querySelector('cart-drawer');
      const drawerLeft = drawer?.classList.contains('active') ? drawer.querySelector('.drawer__inner')?.getBoundingClientRect?.().left : null;
      const available = width >= 750 && Number.isFinite(drawerLeft) && drawerLeft > 100 ? drawerLeft : width;
      box.style?.setProperty('--ips-collagen-notice-left', Math.round(available / 2) + 'px');
      box.style?.setProperty('--ips-collagen-notice-width', Math.max(0, Math.min(440, available - 24)) + 'px');
    };
    const mount = () => {
      if (box.parentElement !== env.document.body) env.document.body.append(box);
    };
    const dismiss = () => { dismissed = true; hide(); };
    box.querySelector('[data-collagen-close]').addEventListener('click', dismiss);
    view.addEventListener('click', async () => {
      if (view.disabled || typeof options.openCart !== 'function') return;
      view.disabled = true;
      view.setAttribute('aria-busy', 'true');
      try { await options.openCart(); dismiss(); }
      catch {
        if (!dismissed) {
          env.clearTimeout(timer);
          message.textContent = options.text?.view_cart_error || 'Please use the cart icon to open your cart.';
          check.hidden = true;
        }
      } finally { view.disabled = false; view.removeAttribute('aria-busy'); }
    });
    const reposition = () => position();
    env.addEventListener?.('resize', reposition, { passive: true });
    env.addEventListener?.('scroll', reposition, { passive: true });
    const header = env.document.querySelector('.section-header');
    const resize = header && typeof env.ResizeObserver === 'function' ? new env.ResizeObserver(reposition) : null;
    if (resize) resize.observe(header);
    return {
      update(value) {
        if (dismissed) { hide(); return; }
        if (successShown) {
          if (value.state !== 'applied') hide();
          return;
        }
        mount();
        hide();
        box.dataset.state = value.state;
        message.textContent = value.message;
        retry.hidden = !value.retry;
        check.hidden = value.state !== 'applied';
        view.hidden = value.state !== 'applied' || typeof options.openCart !== 'function';
        box.hidden = false;
        position();
        if (value.state === 'applied') {
          successShown = true;
          timer = env.setTimeout(dismiss, 6000);
        }
      },
      reset() { dismissed = false; successShown = false; },
      dismiss,
      dispose() { hide(); resize?.disconnect(); env.removeEventListener?.('resize', reposition); env.removeEventListener?.('scroll', reposition); }
    };
  }

  function boot(env) {
    const node = env.document.getElementById('ips-collagen-cart-offer-config');
    const box = env.document.getElementById('ips-collagen-cart-offer');
    if (!node || !box || box.dataset.started === 'true') return;
    let config;
    try { config = JSON.parse(node.textContent); } catch { return; }
    config.root = normalizeRoot(config.root);
    if (!config.enabled || !['ipshealth.co.za', 'www.ipshealth.co.za', SHOP].includes(env.location.hostname) || !parseArrival(env.location.href, config)) return;
    box.dataset.started = 'true';
    const retry = box.querySelector('[data-collagen-retry]');
    let notice;
    const io = browserIo(env, config, value => notice.update(value));
    notice = createNotice(env, box, { openCart: () => io.openCart(), text: config.text });
    const controller = createController(config, io);
    retry.addEventListener('click', () => { notice.reset(); controller.retry(); });
    attachCartRechecks(env, controller, box);
    controller.start();
  }

  const api = { SHOP, LOCK, EXPIRY, normalizeRoot, parseArrival, inspectCart, appliedDiscount, createController, browserIo, attachCartRechecks, createNotice, boot };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (scope.document?.readyState === 'loading') scope.document.addEventListener('DOMContentLoaded', () => boot(scope), { once: true });
  else if (scope.document) boot(scope);
})(typeof window === 'object' ? window : globalThis);
